import LocalPharmacyOutlinedIcon from '@mui/icons-material/LocalPharmacyOutlined'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Espace d'un compte URPS : role de route pose par l'API pour un compte URPS d'une fiche
 * francaise (User::getRoles). Espace Pharmedigroup : pas de `space`, l'URPS n'est pas un
 * laboratoire. La liste a toujours un objet : une fiche URPS porte forcement un territoire.
 */
export const getFrontOfficeGroupUrps = [
  {
    route: 'UrpsPharmacies',
    text: 'Pharmacies',
    t: 'routes.frontoffice.urps.pharmacies',
    icon: LocalPharmacyOutlinedIcon,
    href: '/industryoffice/urps/pharmacies',
    menuHeader: true,
    menuFlat: true,
    position: 10,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_URPS_USER],
}))

export default getFrontOfficeGroupUrps
